"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPulseEffect = exports.isMaterialData = void 0;
const isMaterialData = (effect) => {
    return effect.materialOutput !== undefined;
};
exports.isMaterialData = isMaterialData;
const isPulseEffect = (effect) => effect.type === "pulse";
exports.isPulseEffect = isPulseEffect;
//# sourceMappingURL=IInteractionEffectUtils.js.map